import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { proceedToNextFormStep } from "../../../actions/diversityFormActions";
import {
  StepWrapper,
  Title,
  Paragraph,
  ButtonsWrapper,
  Button,
} from "../styles/diversity-form-styles";

interface Props {
  proceedToNextFormStepAction: typeof proceedToNextFormStep;
}

export const Description: FunctionComponent<Props> = ({
  proceedToNextFormStepAction,
}) => (
  <StepWrapper data-test-id="description-step" description>
    <Title data-test-id="title">Diversity monitoring form</Title>
    <Paragraph data-test-id="paragraph" first>
      Thank you for agreeing to complete this quick questionnaire and helping On
      the Beach in its effort to champion diversity, and ensure it is an
      inclusive employer.
    </Paragraph>
    <Paragraph>
      All the data you submit will be anonymised. We simply collect and
      consolidate this anonymised data from all candidate submissions to On the
      Beach so it can get a better view of diversity and inclusion information
      through its hiring process.
    </Paragraph>
    <Paragraph last>
      Please note, all data you provide will be stored on our platform in
      adherence with the General Data Protection Regulation (GDPR).
    </Paragraph>
    <ButtonsWrapper>
      <Button
        type="button"
        onClick={proceedToNextFormStepAction}
        data-test-id="next-button"
      >
        Continue
      </Button>
    </ButtonsWrapper>
  </StepWrapper>
);

Description.propTypes = {
  proceedToNextFormStepAction: PropTypes.func.isRequired,
};

export default connect(null, {
  proceedToNextFormStepAction: proceedToNextFormStep,
})(Description);
